<template>
  <div class="activity" v-show="view">
    <!-- 砍价活动商品详情 -->
    <div class="heade">
      <!-- <img :src="info.coverImg" alt="" :style="info.goodsStatus == '2'?'opacity:0.3':''" /> -->
      <img :src="info.coverImg"  alt="" >
      <img src="../img/xiajia.png" alt="" style="position: absolute;top: 0;left: 0;right: 0;" v-if="info.goodsStatus == '2'">
    </div>
    <div class="main" :class="info.goodsStatus == '2'||goodsBargain.userBargainStatus == '3'?'mainbg2':'mainbg1'" style="padding-bottom: 2.5rem">
      <div class="item1">
        <div class="line1">
          <span class="color1 fontSize20 font">可砍至&nbsp;&nbsp;</span>
          <span class="color1 fontSize30 font">¥</span>
          <span class="color1 fontSize44 font">{{ goodsBargain.minPrice }}</span>
          <span
            class="color2 fontSize22"
            style="margin-left: 0.4rem; text-decoration: line-through"
            >¥<span class="color2 fontSize30" style="font-family: HelveticaNeue;">{{ goodsBargain.salePrice }}</span>
            </span>
          <div class="rule flex" id="guize" @click="model('guize')">活动规则</div>
        </div>
        <div class="line2">
          <div class="tags" v-if="info.highlights">
            <a v-for="(item, i) in tags" :key="i">{{ item }}</a>
          </div>
        </div>
        <div class="line3">
          <div class="name">{{ info.title }}</div>
        </div>
        <div class="line4">
          <div class="info">
            {{ info.subTitle }}
          </div>
        </div>
        <div v-if="goodsBargain.userBargainStatus == '0'">
          <div class="line5">
            <a class="btn1" id="faqikanjia" @click="xtkanjia()" v-show="info.goodsStatus != '2'">发起砍价</a>
            <a class="btn1" id="chakanqita" @click="shouye()" v-show="info.goodsStatus == '2'">看看其他优惠商品</a>
            <a class="btn2" id="jiaruyaolian" @click="lianxi()">加入药联社群，领取10元红包</a>
          </div>
          <div class="line6" v-if="goodsBargain.ifShowRule == 1">
            <div class="tit">
              <span class="tit-span"><img src="../img/titleft.png" /></span>
              <span class="s1">砍价规则</span>
              <span class="tit-span"><img src="../img/titright.png" /></span>
            </div>
            <div class="info">
              <div v-for="(item, i) in goodsBargain.helpConfig" :key="i">
                {{ i + 1 }}. 助力人数为{{ item.minNum }}-{{
                  item.maxNum
                }}人时，每人砍价可减{{ item.amount }}元；
              </div>
              <div v-if="goodsBargain.helpConfig !== undefined">
                {{ goodsBargain.helpConfig.length + 1 }}. 本活动解释权归药联所有。
              </div>
            </div>
          </div>
          </div>
        </div>
      <div class="item2" v-show="goodsBargain.userBargainStatus != '0'">
        <div class="top" v-if="info.goodsStatus == '1'">
          <div class="times flex" v-if="goodsBargain.userBargainStatus == '1'">
            <date :date="goodsBargain.restSeconds" @dateFn="getMsgFormSon1" type="black"></date
            >&nbsp;&nbsp;后结束
          </div>
          <div class="end" v-if="goodsBargain.userBargainStatus == '3'">
            <img src="../img/end.png" alt="" />
          </div>
          <div class="success" style="padding-bottom: 0.3rem;" v-if="goodsBargain.userBargainStatus == '2'||goodsBargain.userBargainStatus == '5'">
            <img src="../img/success.png" alt="" />
          </div>
          <div class="daizhifu" v-if="goodsBargain.userBargainStatus == '4'">
            <img src="../img/daizhifu.png" alt="" />
          </div>
          <div class="flex" style="color:#535353;" v-if="goodsBargain.userBargainStatus == '2'||goodsBargain.userBargainStatus == '4'">
            <date :date="goodsBargain.restSeconds" @dateFn="getMsgFormSon1" type="black2"></date
            >&nbsp;&nbsp;下单倒计时
            </div>
        </div>
        <div class="bottom" :style="info.goodsStatus == '2'?'padding-top:0.2rem;':goodsBargain.userBargainStatus == '2'||goodsBargain.userBargainStatus == '4'?'padding-top:1.4rem;':''">
          <div class="yikan">已砍至&nbsp;<span>{{goodsBargain.currentPrice}}</span>&nbsp;元</div>
          <div class="progress">
            <van-progress
              :color="(info.goodsStatus == '2'||goodsBargain.userBargainStatus == '3')?'#bbb':'linear-gradient(135deg, #FFA000 0%, #FF6600 100%)'"
              :track-color="(info.goodsStatus == '2'||goodsBargain.userBargainStatus == '3')?'#eee':'#FFEEED'"
              :show-pivot="false"
              stroke-width="14px"
              :percentage="goodsBargain.percentage"
              style="border-radius: 14px"
              v-if="view"
            />
            <div class="jindu">
              <span>原价&nbsp;¥{{goodsBargain.salePrice}}</span>
              <span>可砍至&nbsp;¥{{goodsBargain.minPrice}}</span>
            </div>
          </div>
          <div class="line5" v-if="goodsBargain.userBargainStatus != '2'&&goodsBargain.userBargainStatus != '4'">
            <a class="btn3" @click="shouye()" id="chakanqita" v-if="info.goodsStatus == '2'||goodsBargain.userBargainStatus == '3'||goodsBargain.userBargainStatus == '5'" :style="info.goodsStatus == '2'?'background:#BBBBBB;box-shadow: initial;':''">看看其他优惠商品</a>
            <a class="btn1" @click="model('fenxiang')" v-else>
              <span id="zhaohuanhaoyou" v-if="goodsBargain.wechatAmount == 0">召唤好友，帮我砍价</span>
              <span id="fenxiangqun" v-if="goodsBargain.wechatAmount != 0">{{`分享至微信群，再砍${goodsBargain.wechatAmount}元`}}</span>
            </a>
            <a class="btn2" id="jiaruyaolian" @click="lianxi()">加入药联社群，领取10元红包</a>
          </div>
          <div class="line6" v-if="goodsBargain.ifShowRule == 1">
            <div class="tit">
              <span class="tit-span"><img src="../img/titleft.png" /></span>
              <span class="s1">砍价规则</span>
              <span class="tit-span"><img src="../img/titright.png" /></span>
            </div>
            <div class="info">
              <div v-for="(item, i) in goodsBargain.helpConfig" :key="i">
                {{ i + 1 }}. 助力人数为{{ item.minNum }}-{{
                  item.maxNum
                }}人时，每人砍价可减{{ item.amount }}元；
              </div>
              <div>{{ goodsBargain.helpConfig.length + 1 }}.本活动解释权归药联所有.</div>
            </div>
          </div>
          <div class="line6" style="margin-top: 0.2rem">
            <div class="tit">
              <span class="tit-span"><img src="../img/titleft.png" /></span>
              <span class="s1">砍价记录</span>
              <span class="tit-span"><img src="../img/titright.png" /></span>
            </div>
            <div :style="recordList&&recordList.length>5?'max-height:4rem;overflow-y: scroll;':''" v-if="recordList&&recordList.length>0">
              <div class="list" v-for="(item, i) in recordList" :key="i">
              <div class="left"><img :src="item.headUrl" alt="" /></div>
              <div class="middle">{{item.name}}</div>
              <div class="right">砍掉 {{item.amount}} 元</div>
            </div>
            </div>
            <van-empty description="" v-else/>
          </div>
        </div>
      </div>
      <div class="item3">
        <div class="cell" id="shangpinfuwu" @click="shangpin()">
          <span>商品包含以下服务</span>
          <van-icon name="arrow" color="#999" />
        </div>
      </div>
      <div class="item4">
        <h1>商品详情</h1>
        <readAgerr
            ref="readAgeer"
            type="1"
            button="2"
            :isAgent="isAgent"
            :info="info"
            :goodsBargain="goodsBargain"
            @noticeParent1="noticeParent1"
            v-show="show">
          </readAgerr>
        <div class="txt ql-editor" v-html="info.goodsDetail" id="htmlText"></div>
      </div>
      <div class="footer">
        <action
            type="1"
            button="2"
            :isAgent="isAgent"
            :info="info"
            :goodsBargain="goodsBargain"
            @noticeParent1="noticeParent1"
            v-show="show"
          ></action>
      </div>
    </div>

    <div id="saveImg" ref="saveBox">
      <!-- <img src="../img/changan2.png" alt="" /> -->
      <img class="saveBg" src="../img/saveImg.png">
     <div class="info">
        <img
          :src="goodsBargain.helpImg"
          alt=""
          style="width: 100%;height:37%"
        />
        <div class="code">
          <vue-qr
          :text="shareUrl"
          :margin="0"
          colorDark="#000"
          colorLight="#fff"
          logoSrc=""
          :logoScale="0.2"
          :size="200"
        ></vue-qr>
          <p>长按识别二维码或扫码查看</p>
        </div>
      </div>
    </div>
    <van-overlay :show="guanzhu" z-index="2009">
      <div class="wrapper isFollow">
        <div class="block" style="border-radius: 0.28rem;padding:0.6rem 1.2rem;text-align: center;">
          <div style="color: #555;padding-bottom:0.3rem;font-size:0.28rem;">关注 <span>药联健康服务 </span>公众号</div>
          <h2>发起砍价活动</h2>
          <img src="../img/is-guanzhu.png" alt="" class="code">
          <div style="font-family: PingFangSC-Medium, PingFang SC;">长按识别二维码</div>
        </div>
        <img
            src="../img/close.png"
            style="width: 0.6rem"
            @click="guanzhuClose()"
          />
      </div>
    </van-overlay>
    <overlay
      :type="type"
      :info="info"
      @dateFn="getMsgFormSon2"
      :goodsBargain="goodsBargain"
      :kanjiaInfo="kanjiaInfo"
      :kanjiaType="kanjiaType"
      :saveImg = img_url
      :shareUrl = shareUrl
    ></overlay>
    <van-overlay :show="fenxiangkanjia" ref="progress" z-index="2009">
      <div class="wrapper kanjia" id="haoyoubangkan">
        <div class="block" style="width:5rem;">
          <div class="topImg2" style="margin-top: -1.9rem">
            <img src="../img/fenxiangkanjia.png" style="width: 3.3rem" v-show="kanjiaType=='qun'" />
            <img src="../img/kanjia-success.png" style="width: 3.3rem" v-show="kanjiaType=='haoyou'"/>
          </div>
          <div class="friends">
            <div v-if="goodsBargain.avatarArr&&goodsBargain.avatarArr.length >0">
              <div class="tou" v-if="goodsBargain.avatarArr&&goodsBargain.avatarArr.length>5">
                <img :src="item" alt="" v-for="(item,index) in goodsBargain.avatarArr.slice(0,3)" :key="index" />
                <img src="../img/guo.png" alt="">
                <img :src="item" alt="" v-for="(item,index) in goodsBargain.avatarArr.slice(-1)" :key="index" />
              </div>
              <div class="tou" v-else>
                <img :src="item" alt="" v-for="(item,index) in goodsBargain.avatarArr" :key="index" />
              </div>
              <div class="name">{{goodsBargain.avatarArr.length >1?`${goodsBargain.name}…等人`:`${goodsBargain.name}`}}</div>
            </div>
          </div>
          <div class="info" v-show="kanjiaType=='qun'">
            又帮您砍掉&nbsp;<span>{{kanjiaInfo.amount}}</span>&nbsp;元，已砍至&nbsp;<span>{{kanjiaInfo.currentPrice}}</span>&nbsp;元
          </div>
          <div class="info" style="padding-top: 0.4rem" v-show="kanjiaType=='haoyou'">
            成功帮您砍掉&nbsp;<span>{{goodsBargain.newBargainAmount}}</span>&nbsp;元，已砍至&nbsp;<span>{{goodsBargain.currentPrice}}</span>&nbsp;元
          </div>
          <div class="progress">
            <!-- <van-progress
              color="linear-gradient(135deg, #FFA000 0%, #FF6600 100%)"
              track-color="#FFEEED"
              :show-pivot="false"
              stroke-width="14px"
              :percentage="goodsBargain.percentage"
              style="border-radius: 14px"
              v-if="view"
            /> -->
                <span class="progress_out">
                    <span class="progress_in" :style="{width:goodsBargain.percentage+'%'}"></span>
                </span>
            <div class="jindu">
             <span>原价&nbsp;¥{{goodsBargain.salePrice}}</span>
              <span>可砍至&nbsp;¥{{goodsBargain.minPrice}}</span>
            </div>
          </div>
          <div class="btn" id="fenxiangzaikan" @click="model('fenxiang2')" v-if="this.goodsBargain.userBargainStatus != '2'">
            <a class="flex"
              ><img
                src="../img/ico_wx.png"
                alt=""
                style="width: 0.4rem"
              />&nbsp;分享好友，再砍一刀</a
            >
          </div>
        </div>
        <img
          src="../img/close.png"
          style="width: 0.6rem"
          @click="close()"
        />
      </div>
    </van-overlay>
    <van-action-sheet
      v-model="shangpinfuwu"
      title="商品包含以下服务"
      class="shangpinfuwu"
      @cancel="shangpinguanbi"
    >
      <div class="content" id="shangpinfuwutankuang" style="max-height: 6rem;overflow-y: scroll;padding: 0.4rem" v-if="info.items && info.items.length>0">
        <van-card
          v-for="(item, i) in info.items"
          :key="i"
          :num="item.itemGoodsNumbers"
          :price="item.itemSalePrice"
          :title="item.itemGoodsTitle"
          :thumb="
            item.itemGoodsCoverImg
              ? item.itemGoodsCoverImg
              : require('../img/default.png')
          "
        />
      </div>
      <van-empty description="" id="shangpinfuwutankuang" v-else/>
    </van-action-sheet>
  </div>
</template>
<script>
import action from "./action";
import readAgerr from './read'
import overlay from "./overlay";
import date from "../../common/date/date";
import getWXSign from '../../../libs/wxSign'
import apiServe from '../../../libs/apiServe';
import {debounce} from 'lodash'
import html2canvas from "html2canvas";
import vueQr from "vue-qr";
import config from "@/libs/config";
export default {
  components: {
    action,
    date,
    overlay,
    vueQr,
    readAgerr
  },
  data() {
    return {
      view: false,
      show: true,
      shangpinfuwu: false,
      canSubmit: true,
      type: "",
      isAgent: "",
      info: {},
      tags: [],
      recordList:[],
      goodsBargain: {},
      kanjiaInfo:{},
      kanjiaType:"",
      fenxiangkanjia:false,
      keepAlive:true,
      channelType:"",
      img_url:"",
      shareUrl:"",
      guanzhu:false,
      followStatus:""
    };
  },
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value&&value.length > 6) {
        return value.slice(0, 6);
      }
      return value;
    },
  },
  created() {
    let isPageHide = false;
    window.addEventListener('pageshow', function () {
        if (isPageHide) {
            window.location.reload();
        }
    });
    window.addEventListener('pagehide', function () {
        isPageHide = true;
    });
    this.isAgent = JSON.parse(sessionStorage.getItem("user")).isAgent;
    this.channelType = JSON.parse(sessionStorage.getItem("user")).channelType;
    this.detail();
  },
  methods: {
    detail() {
      let {
        skuNo,
        channel,
        shareMemberId,
        saleMerchantId,
        saleStoreId,
        assistantId,
        sellType,
        sellLabel,
        redirect,
      } = this.$route.query;
      let post = {
        shareMemberId,
        channel,
        skuNo,
        saleMerchantId,
        saleStoreId,
        assistantId,
        sellType,
        redirect,
        sellLabel,
        memberId: JSON.parse(sessionStorage.getItem("user")).memberId,
      };
      this.$api.goodsDetail2(post).then((res) => {
        if (res.errno == "0") {
          res.data.explainNames.forEach((item,index,array)=>{
              if(item.explainType == '3') item.explainTypeName = '服务说明'
          })
          this.info = res.data;
          this.tags = this.info.highlights.split(",");
          this.goodsBargainInfo();
          if(this.info.goodsStatus == '2'){
            this.show = false
            this.$toast("该商品已下架，试试别的商品吧");
          }
        }
      });
    },
    goodsBargainInfo() {
      let { skuNo,shareMemberId,recordId,sellType,sellLabel,channel } = this.$route.query;
      let post = {
        skuNo,
        recordId,
        channel,
        shareMemberId,
        sellType,
        sellLabel
      };
      this.$api.goodsBargain(post).then((res) => {
        if (res.errno == "0") {
          this.goodsBargain = res.data;
          if(this.info.goodsStatus == '2'||this.goodsBargain.userBargainStatus == '3'||this.goodsBargain.userBargainStatus == '5'){
            this.show = false
          }else{
            if(this.goodsBargain.newBargainAmount > 0){
              this.fenxiangkanjia = true
              this.kanjiaType = 'haoyou'
              this.$trackFn.send("click_material", {
                page_type: "good_detailh5",
                page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
                item_id:this.info.skuNo,
                item_type:"product_id",
                card_type: "bargained",
                sell_type:sellType,
                sell_label:sellLabel,
                sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
                material_type:'friends',
              });
            }
          }
          this.getRecordList()
          if(this.channelType == 'wechat') this.wxShare()
          if(this.channelType == 'app') this.appShare()
          let {
                channel,
                shareMemberId,
                sellType,
                sellLabel,
              } = this.$route.query;
          let time1 = new Date().getTime();
          window.onbeforeunload = (e) => {
            let time2 = new Date().getTime();
            let dateDiff = (time2 - time1) / 1000;
            let page_type = "good_detailh5";
            this.$trackFn.view("$pageview", {
              page_type: page_type,
              page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
              event_duration: dateDiff,
              sell_type:"retailstore",
              item_id:this.info.skuNo,
              item_type:"product_id",
              sell_type:"retailstore",
            }); // 商品列表页 ——浏览埋点
            sessionStorage.setItem("pageType", page_type);
            // return "关闭提示";
          };
          this.$nextTick(() => {
            this.$trackFn.load("faqikanjia", "view_material", {
              // 发起砍价中间曝光 - 埋点
              page_type: "good_detailh5",
              page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
              card_type: "middle_bar",
              card_id:shareMemberId,
              item_id:this.info.skuNo,
              item_type:"product_id",
              sell_type:sellType,
              sell_label:sellLabel,
              sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
              material_type:"bargain_start",
            });
          });
          this.$nextTick(() => {
            this.$trackFn.load("faqikanjiadi", "view_material", {
              page_type: "good_detailh5",
              page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
              card_type: "bottom_bar",
              card_id:shareMemberId,
              item_id:this.info.skuNo,
              item_type:"product_id",
              sell_type:sellType,
              sell_label:sellLabel,
              sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
              material_type:"bargain_start",

            });
          });
          this.$nextTick(() => {
            this.$trackFn.load("fenxiangqun", "view_material", {
              page_type: "good_detailh5",
              page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
              card_type: "middle_bar",
              card_id:shareMemberId,
              item_id:this.info.skuNo,
              item_type:"product_id",
              sell_type:sellType,
              sell_label:sellLabel,
              sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
              material_type:"bargain__group",
            });
          });
          this.$nextTick(() => {
            this.$trackFn.load("zhaohuanhaoyou", "view_material", {
              page_type: "good_detailh5",
              page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
              card_type: "middle_bar",
              card_id:shareMemberId,
              item_id:this.info.skuNo,
              item_type:"product_id",
              sell_type:sellType,
              sell_label:sellLabel,
              sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
              material_type:"bargain_friends",
            });
          });
          this.$nextTick(() => {
            this.$trackFn.load("chakanqita", "view_material", {
              page_type: "good_detailh5",
              page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
              card_type: "middle_bar",
              card_id:shareMemberId,
              item_id:this.info.skuNo,
              item_type:"product_id",
              sell_type:sellType,
              sell_label:sellLabel,
              sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
              material_type:"more",
            });
          });
          this.$nextTick(() => {
            this.$trackFn.load("jiaruyaolian", "view_material", {
              page_type: "good_detailh5",
              page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
              card_type: "middle_bar",
              card_id:shareMemberId,
              item_id:this.info.skuNo,
              item_type:"product_id",
              sell_type:sellType,
              sell_label:sellLabel,
              sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
              material_type:"community",
            });
          });
          this.$nextTick(() => {
            this.$trackFn.load("fenxiangzaikan", "view_material", {
              page_type: "good_detailh5",
              page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
              card_type: "bargained_bar",
              card_id:shareMemberId,
              item_id:this.info.skuNo,
              item_type:"product_id",
              sell_type:sellType,
              sell_label:sellLabel,
              sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
              material_type:"bargain_friends2",
            });
          });
          this.$nextTick(() => {
            this.$trackFn.load("fenxianghaibao", "view_material", {
              page_type: "good_detailh5",
              page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
              card_type: "bargain_poster",
              card_id:shareMemberId,
              item_id:this.info.skuNo,
              item_type:"product_id",
              sell_type:sellType,
              sell_label:sellLabel,
              sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
              material_type:"poster",
            });
          });
          this.$nextTick(() => {
            this.$trackFn.load("fenxianghaibao", "view_material", {
              page_type: "good_detailh5",
              page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
              card_type: "bargain_poster_bar",
              card_id:shareMemberId,
              item_id:this.info.skuNo,
              item_type:"product_id",
              sell_type:sellType,
              sell_label:sellLabel,
              sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
              material_type:"preserve",
            });
            });
          this.$nextTick(() => {
            this.$trackFn.load("huodongjiamai", "view_material", {
              page_type: "good_detailh5",
              page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
              card_type: "bottom_bar",
              card_id:shareMemberId,
              item_id:this.info.skuNo,
              item_type:"product_id",
              sell_type:sellType,
              sell_label:sellLabel,
              sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':channel=='1'||channel == '2'?'ydbapp':channel == '3'?'wx_off':channel == '4'?'wxarticle':'',
              material_type:"middle_price",
            });
          });
          this.$nextTick(() => {
            this.$trackFn.load("jiaruyaolian", "view_material", {
              page_type: "good_detailh5",
              page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
              card_type: "bottom_bar",
              card_id:shareMemberId,
              item_id:this.info.skuNo,
              item_type:"product_id",
              sell_type:sellType,
              sell_label:sellLabel,
              sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
              material_type:"floor_price",
            });
          });
          this.$nextTick(() => {
            this.$trackFn.load("haoyoubangkan", "view_material", {
              page_type: "good_detailh5",
              page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
              card_type: "bargained",
              card_id:shareMemberId,
              item_id:this.info.skuNo,
              item_type:"product_id",
              sell_type:sellType,
              sell_label:sellLabel,
              sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
              material_type:"friends",
            });
          });
          this.$nextTick(() => {
            this.$trackFn.load("yuanjiagoumai", "view_material", {
              page_type: "good_detailh5",
              page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
              card_type: "bottom_bar",
              card_id:shareMemberId,
              item_id:this.info.skuNo,
              item_type:"product_id",
              sell_type:sellType,
              sell_label:sellLabel,
              sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
              material_type:"original_price",
              material_link:this.info.orderSubmitUrl
            });
          });
          this.$nextTick(() => {
            this.$trackFn.load("quxiaodingdan", "view_material", {
              page_type: "good_detailh5",
              page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
              card_type: "bottom_bar",
              card_id:shareMemberId,
              item_id:this.info.skuNo,
              item_type:"product_id",
              sell_type:sellType,
              sell_label:sellLabel,
              sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
              material_type:"cancel"
            });
          });
          this.$nextTick(() => {
            this.$trackFn.load("lijifukuan", "view_material", {
              page_type: "good_detailh5",
              page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
              card_type: "bottom_bar",
              card_id:shareMemberId,
              item_id:this.info.skuNo,
              item_type:"product_id",
              sell_type:sellType,
              sell_label:sellLabel,
              sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
              material_type:"payment"
            });
          });
          this.$nextTick(() => {
            this.$trackFn.load("fenxiangqun", "view_material", {
              page_type: "good_detailh5",
              page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
              card_type: "bargained_bar",
              card_id:shareMemberId,
              item_id:this.info.skuNo,
              item_type:"product_id",
              sell_type:sellType,
              sell_label:sellLabel,
              sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
              material_type:"bargain__group"
            });
          });
          this.$nextTick(() => {
            this.$trackFn.load("xitongkanjia", "view_material", {
              page_type: "good_detailh5",
              page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
              card_type: "bargained",
              card_id:shareMemberId,
              item_id:this.info.skuNo,
              item_type:"product_id",
              sell_type:sellType,
              sell_label:sellLabel,
              sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
              material_type:this.goodsBargain.wechatAmount == 0?'system':'group'
            });
          });
          let href = encodeURIComponent(window.location.href)
          this.$nextTick(() => {
            this.$trackFn.load("tuijianhaoyou2", "view_material", {
              page_type: "good_detailh5",
              page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
              card_type: "bottom_bar",
              card_id:shareMemberId,
              item_id:this.info.skuNo,
              item_type:"product_id",
              sell_type:sellType,
              sell_label:sellLabel,
              sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
              material_type:"share",
              material_link:`${window.location.origin}/bill&url${href}`
            });
          });
          this.info.explainNames.forEach((item, index) => {
          this.$nextTick(() => {
            this.$trackFn.load("tioakuanxieyi", "view_material", {
              // 曝光 - 埋点
              page_type: "good_detailh5",
              page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
              card_type: item.explainTypeName == '投保须知'?'insure':item.explainTypeName == '保险条款'?'clause':item.explainTypeName == '健康告知书'?'inform':'agreement',
              item_id:this.info.skuNo,
              item_type:"product_id",
              sell_type:sellType,
              sell_label:sellLabel,
              sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
              material_type:"btn"
            });
          });
          })
          this.$nextTick(() => {
            this.$trackFn.load("guize", "view_material", {
              // 活动规则按钮曝光 - 埋点
              page_type: "good_detailh5",
              page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
              card_type: "rule",
              card_id:shareMemberId,
              item_id:this.info.skuNo,
              item_type:"product_id",
              sell_type:sellType,
              sell_label:sellLabel,
              sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
              material_type:"btn"
            });
          });
          this.$nextTick(() => {
            this.$trackFn.load("shangpinfuwu", "view_material", {
              // 活动规则按钮曝光 - 埋点
              page_type: "good_detailh5",
              page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
              card_type: "content",
              card_id:shareMemberId,
              item_id:this.info.skuNo,
              item_type:"product_id",
              sell_type:sellType,
              sell_label:sellLabel,
              sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
              material_type:"btn"
            });
          });
        }
      });
    },
    getRecordList(){ 
      this.$api.helpRecordList({recordId:this.goodsBargain.recordId}).then((res) => {
        if (res.errno == "0") {
          this.recordList = res.data.body
        }
      });
    },
    toBase64(img){
      this.$api.imgToBase64({img:img}).then((res) => {
          if (res.errno == "0") {
            this.goodsBargain.helpImg = res.data.imageBase64
            this.get_img()
          }
      });
    },
    order:debounce(function(){
      let {shareMemberId,channel,saleMerchantId,saleStoreId,sellType,sellLabel} = this.$route.query;
      let postData = {
        recordId: this.goodsBargain.recordId,
        shareMemberId,
        channel,
        merchantId: saleMerchantId,
        storeId:saleStoreId,
        sellType,
        sellLabel
      }
      this.$api.bargainOrder(postData)
        .then((res) => {
          if (res.errno == "0") {
            if(res.data.activityOrder == '1'){
              if(res.data.orderStatus == '1'){
                location.href = res.data.payUrl
              }else{
                this.$toast({
                    message: "购买成功",
                    icon: require("../img/ico_succeed 2.png"),
                    className: "kanjiaxiadan",
                  });
                  setTimeout(() => {
                    location.href = `${config.config().wx}/v/list`
                  }, 2000);
              }
              let {channel,shareMemberId,sellType,sellLabel,} = this.$route.query;
              this.$trackFn.send("click_material", {
                page_type: "good_detailh5",
                page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
                item_id:this.info.skuNo,
                item_type:"product_id",
                card_type: "bottom_bar",
                card_id:shareMemberId,
                sell_type:sellType,
                sell_label:sellLabel,
                sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
                material_type:this.goodsBargain.userBargainStatus == '2'?"floor_price":"middle_price",
                material_link:res.data.orderStatus == '1'?res.data.payUrl:''
              });
            }else{
              location.href = this.info.orderSubmitUrl
            }
          }
      });
    }, 300),
    orderCancel:debounce(function(){
      this.$api.orderCancel({mainOrderNo:this.goodsBargain.mainOrderNo})
              .then((res) => {
                if (res.errno === "0") {
                  this.$toast({
                        message: "取消订单成功",
                        icon: require("../img/ico_succeed 2.png"),
                        className: "kanjiaxiadan",
                      });
                  setTimeout(() => {
                    this.$router.go(0)
                  }, 2000);
                }
            });
            let {channel,shareMemberId,sellType,sellLabel} = this.$route.query;
                this.$trackFn.send("click_material", {
                  page_type: "good_detailh5",
                  page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
                  item_id:this.info.skuNo,
                  item_type:"product_id",
                  card_type: "bottom_bar",
                  card_id:shareMemberId,
                  sell_type:sellType,
                  sell_label:sellLabel,
                  sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
                  material_type:"cancel"
                });
    }, 300),
    noticeParent1(event){
      console.log(event)
      if(event == 'xtkanjia'){
        this.xitongkanjia()
      }
      if(event == 'fenxiangqun'||event == 'fenxianghaoyou'){
        this.type = "fenxiang"
        this.goodsBargainInfo()
      }
      if(event == 'xiadan'){
        this.order()
      }
      if(event == 'quxiaodingdan'){
        this.orderCancel()
      }
      let {channel,shareMemberId,sellType,sellLabel,} = this.$route.query;
      this.$trackFn.send("click_material", {
        page_type: "good_detailh5",
        page_attr:this.goodsBargain?(this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf'):'normal',
        item_id:this.info.skuNo,
        item_type:"product_id",
        card_type: "bargained_bar",
        card_id:shareMemberId,
        sell_type:sellType,
        sell_label:sellLabel,
        sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
        material_type:event == 'fenxiangqun'?'bargain__group':event == 'fenxianghaoyou'?'bargain_friends1':''
      });
    },
    guanzhuClose(){
      this.guanzhu = false
    },
    isFollow(){
      this.$api.isFollow({openid:JSON.parse(sessionStorage.getItem("user")).openid}).then((res) => {
          if (res.errno == "0") {
            this.followStatus = res.data.followStatus
          }
      });
    },
    xtkanjia(){
      this.xitongkanjia()
      let {
        channel,
        shareMemberId,
        sellType,
        sellLabel,
      } = this.$route.query;
      this.$trackFn.send("click_material", {
        // 点击 - 埋点
        page_type: "good_detailh5",
        page_attr:"no_started",
        card_type: "middle_bar",
        card_id:shareMemberId,
        item_id:this.info.skuNo,
        item_type:"product_id",
        sell_type:sellType,
        sell_label:sellLabel,
        sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
        material_type:"bargain_start"
      });
      this.$trackFn.send("click_material", {
        // 点击 - 埋点
        page_type: "good_detailh5",
        page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
        card_type: "bargained",
        card_id:shareMemberId,
        item_id:this.info.skuNo,
        item_type:"product_id",
        sell_type:sellType,
        sell_label:sellLabel,
        sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
        material_type:"system"
      });
    },
    xitongkanjia() {
      this.$api.isFollow({openid:JSON.parse(sessionStorage.getItem("user")).openid}).then((res) => {
          if (res.errno == "0") {
            this.followStatus = res.data.followStatus
            if(this.followStatus == '2') return this.guanzhu = true
            // 系统砍价
            let { channel,shareMemberId,sellType,sellLabel } = this.$route.query;
            let postData = {
              bargainId: this.goodsBargain.bargainId,
              channel,
              sellType,
              sellLabel,
              shareMemberId,
            };
            this.$api.xitongkanjia(postData).then((res) => {
              if (res.errno == "0") {
                if(res.data.systemAmount > 0){
                  this.kanjiaInfo = res.data
                  this.type = "xitongkanjia"
                  this.goodsBargainInfo()
                }else{
                  this.type = 'fenxiang'
                  this.goodsBargainInfo()
                }
              }
            });
          }
      });
    },
    qunkan(){
      // 微信群砍价
      let postData = {
        bargainId: this.goodsBargain.bargainId,
        recordId:this.goodsBargain.recordId,
        type:'2'
      };
      this.$api.helpBargain(postData).then((res) => {
        if (res.errno == "0") {
          this.type = ""
          this.fenxiangkanjia = true
          this.kanjiaType = "qun"
          this.kanjiaInfo = res.data
          this.goodsBargainInfo()
        }
      });
      this.$trackFn.send("click_material", {
        // 点击 - 埋点
        page_type: "good_detailh5",
        page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
        card_type: "bargained",
        card_id:shareMemberId,
        item_id:this.info.skuNo,
        item_type:"product_id",
        sell_type:sellType,
        sell_label:sellLabel,
        sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
        material_type:"group"
      });
    },
    wxShare(){
      getWXSign()
            .then(jssdk => {
              let { skuNo,shareMemberId,recordId,sellType,sellLabel,channel } = this.$route.query;
              let post = {
                skuNo,
                recordId:this.goodsBargain.recordId,
                channel,
                shareMemberId,
                sellType,
                sellLabel
              };
                this.$api.bargainShare(post).then(res => {
                    const configData = res.data;
                    this.shareUrl = configData.shareUrl
                    this.view = true;
                    this.toBase64(this.goodsBargain.helpImg)
                    jssdk.updateAppMessageShareData({
                        title: configData.title, // 分享标题
                        desc: configData.subtitle, // 分享描述
                        link: configData.shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                        imgUrl: configData.picUrl, // 分享图标
                        success: function () {}
                    })
                })
            })
    },
    appShare(){
      let { skuNo,shareMemberId,recordId,sellType,sellLabel,channel } = this.$route.query;
      let post = {
        skuNo,
        recordId:this.goodsBargain.recordId,
        channel,
        shareMemberId,
        sellType,
        sellLabel
      };
      apiServe.bargainShare(post).then(res => {
        const configData = res.data;
        this.shareUrl = configData.shareUrl
        this.view = true;
        this.toBase64(this.goodsBargain.helpImg)
        let sharObj = { 
          shareLink:configData.shareUrl, 
          shareTitle:configData.title, 
          shareDescr:configData.subtitle, 
          shareImg:configData.picUrl, 
        }
        UnionDrugHealthy.showShareIcon(JSON.stringify(sharObj))
    })
    },
    shouye() {
      // this.$router.push("/goodsHome");
      location.href = `${window.location.origin}/distribution/goodsHome`
      let {channel,shareMemberId,sellType,sellLabel,} = this.$route.query;
      this.$trackFn.send("click_material", {
            page_type: "good_detailh5",
            item_id:this.info.skuNo,
            item_type:"product_id",
            card_type: "middle_bar",
            card_id:shareMemberId,
            sell_type:sellType,
            sell_label:sellLabel,
            sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
            material_type:"more",
            material_link:`${window.location.origin}/goodsHome?jumpType=1`
          });
    },
    lianxi() {
      // this.$router.push("/call");
      location.href = `${window.location.origin}/distribution/call`
      let {channel,shareMemberId,sellType,sellLabel,} = this.$route.query;
      this.$trackFn.send("click_material", {
            page_type: "good_detailh5",
             page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
            item_id:this.info.skuNo,
            item_type:"product_id",
            card_type: "middle_bar",
            card_id:shareMemberId,
            sell_type:sellType,
            sell_label:sellLabel,
            sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
            material_type:"community",
            material_link:`${window.location.origin}/call`
          });
    },
    model(type) {
      console.log(type);
      this.type = type;
      this.fenxiangkanjia = false
      let {channel,shareMemberId,sellType,sellLabel,} = this.$route.query;
      if(type="guize"){
        this.$trackFn.send("click_material", {
          page_type: "good_detailh5",
          page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
          item_id:this.info.skuNo,
          item_type:"product_id",
          card_type: "rule",
          card_id:shareMemberId,
          sell_type:sellType,
          sell_label:sellLabel,
          sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
          material_type:"btn"
        });
        this.$nextTick(() => {
            this.$trackFn.load("guizetankuang", "view_material", {
              // 商品详情部分曝光 - 埋点
              page_type: "good_detailh5",
              page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
              card_type: "rule_popup",
              card_id:shareMemberId,
              item_id:this.info.skuNo,
              item_type:"product_id",
              sell_type:sellType,
              sell_label:sellLabel,
              sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
              material_type:"popup"
            });
          });
      }
      if(type == 'fenxiang'||type == 'fenxiang2'){
        let { sellType,sellLabel,channel,shareMemberId } = this.$route.query;
        this.$trackFn.send("click_material", {
            page_type: "good_detailh5",
            page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
            item_id:this.info.skuNo,
            item_type:"product_id",
            card_type: type == 'fenxiang'?"middle_bar":'bargained_bar',
            card_id:shareMemberId,
            sell_type:sellType,
            sell_label:sellLabel,
            sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
            material_type:type == 'fenxiang'?(this.goodsBargain.wechatAmount>0?"bargain__group":'bargain_friends'):"bargain_friends2"
          });
      }
    },
    getMsgFormSon1(times) {
      console.log("通知秒数剩余", times);
      if(this.goodsBargain.userBargainStatus == '1'){
          this.goodsBargain.userBargainStatus = '3'
          this.show = false
      }
    },
    getMsgFormSon2(type) {
      console.log("弹框来源", type);
      this.type = "";
      if(type == 'xitongkanjia'||type=='fenxiangkanjia'){
        this.$router.go(0)
      }
      if(type == 'fenxiang'){
        if(this.goodsBargain.wechatAmount > 0){
          this.qunkan()
          }
      }
      if(type == 'gengxin'){
        this.type = 'fenxiang'
        this.goodsBargainInfo()
        // this.$router.go(0)
      }
      if(type == 'fenxiangtankuang'){
        this.type = 'fenxiang'
      }
      let {channel,shareMemberId,sellType,sellLabel,} = this.$route.query;
      this.$trackFn.send("click_material", {
        page_type: "good_detailh5",
        page_attr:this.goodsBargain?(this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf'):'normal',
        item_id:this.info.skuNo,
        item_type:"product_id",
        card_type: type == 'guize'?'rule_bar':'bar_popup_bar',
        card_id:shareMemberId,
        sell_type:sellType,
        sell_label:sellLabel,
        sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
        material_type:"close"
      });
    },
    shangpin(){
      this.shangpinfuwu = true
      let { skuNo,recordId,shareMemberId,sellType,sellLabel,channel } = this.$route.query;
      this.$trackFn.send("click_material", {
        page_type: "good_detailh5",
        page_attr:this.goodsBargain?(this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf'):'normal',
        item_id:this.info.skuNo,
        item_type:"product_id",
        card_type: "content",
        card_id:shareMemberId,
        sell_type:sellType,
        sell_label:sellLabel,
        sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
        material_type:"btn"
      });
      this.$nextTick(() => {
      this.$trackFn.load("shangpinfuwutankuang", "view_material", {
        // 商品详情部分曝光 - 埋点
        page_type: "good_detailh5",
        page_attr:this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf',
        card_type: "content_popup",
        card_id:shareMemberId,
        item_id:this.info.skuNo,
        item_type:"product_id",
        sell_type:sellType,
        sell_label:sellLabel,
        sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
        material_type:"popup"
      });
    });
    },
    shangpinguanbi(){
      let { skuNo,shareMemberId,recordId,sellType,sellLabel,channel } = this.$route.query;
      this.$trackFn.send("click_material", {
        // 商品服务点击 - 埋点
        page_type: "good_detailh5",
        page_attr:this.goodsBargain?(this.info.goodsStatus == '1'?this.goodsBargain.userBargainStatus == '0'?'no_started':this.goodsBargain.userBargainStatus == '3'?'finished':'ongoing':'off_shelf'):'normal',
        item_id:this.info.skuNo,
        item_type:"product_id",
        card_type: "content_bar",
        card_id:shareMemberId,
        sell_type:sellType,
        sell_label:sellLabel,
        sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
        material_type:"close"
      });
    },
    get_img() {
      this.$nextTick(() => {
      var content_html = document.getElementById("saveImg"); //要转化的div
      if (this.isiOS) {
        var opts = {
          useCORS: true,
          width: content_html.offsetWidth,
          height: content_html.offsetHeight,
          windowWidth: document.body.scrollWidth,
          windowHeight: document.body.scrollHeight,
          x: 0,
          y: window.pageYOffset,
        };
      } else {
        var opts = {
          useCORS: true,
          width: window.screen.availWidth,
          height: window.screen.availHeight,
          windowWidth: document.body.scrollWidth,
          windowHeight: document.body.scrollHeight,
          x: 0,
          y: window.pageYOffset,
        };
      }

      let myBox = this.$refs.saveBox;
      html2canvas(myBox, opts).then((canvas) => {
        let data = canvas.toDataURL();
        this.img_url = data;
      });
      })
    },
    close(){
      this.fenxiangkanjia = false
      this.$router.go(0)
    }
  },
  // beforeRouteLeave(to, from, next) {
  //   console.log("beforeRouteLeave", to);
  //   if (to.path == "/log") {
  //     to.meta.keepAlive = this.keepAlive;
  //   } else {
  //     to.meta.keepAlive = false;
  //   }
  //   next();
  // },
};
</script>
<style lang="scss" scoped>
.activity {
  height: 100vh;
  overflow-y: scroll;
  .heade {
      position: relative;
    // background: rgba(0, 0, 0, 1) url("../img/xiajia.png") top no-repeat;
    // background-size: contain;
    // background-position-x: 1rem;
    img{
      max-height: 6.3rem;
    }
  }
  .main {
    position: relative;
    z-index: 9;
    margin-top: -0.1rem;
    padding: 0.2rem 0.2rem;
    border-radius: 16px 16px 0px 0px;
    .item1,
    .item2,
    .item3,
    .item4 {
      background: #fff;
      border-radius: 16px;
      padding: 0.4rem 0.3rem 0.2rem;
      margin-bottom: 0.2rem;
    }
    .item1 {
      .line1,
      .line2,
      .line3,.line4 {
        margin-bottom: 0.3rem;
      }
      .line1 {
        position: relative;
      }
      .rule {
        position: absolute;
        right: -5%;
        top: 18%;
        height: 40px;
        width: 112px;
        font-size: 0.2rem;
        color: #fff;
        background: #ff8e00;
        border-radius: 24px 0px 0px 24px;
      }
      .line2 {
        .tags {
          line-height: 0.6rem;
          a {
            color: #ff8800;
            background: rgba(255, 136, 0, 0.1);
            border-radius: 4px;
            font-size: 24px;
            margin-right: 20px;
            padding: 6px 10px;
          }
        }
      }
      .line3 {
        .name {
          font-size: 36px;
          font-family: PingFangSC-Semibold, PingFang SC;
          color: #333333;
        }
      }
      .line4 {
        .info {
          font-size: 28px;
          font-weight: 400;
          color: #666666;
        }
      }
    }
    .item2 {
      position: relative;
      .top {
        position: absolute;
        top: -1%;
        left: 0;
        right: 0;
        text-align: center;
        .times {
          width: 350px;
          margin-top: 0.13rem;
          padding: 16px 0;
          border-radius: 0px 0px 20px 20px;
          background: rgba(255, 136, 0, 0.1);
          display: inline-flex;
        }
        .end,
        .success,.daizhifu {
          width: 436px;
          margin: auto;
        }
      }
      .bottom {
        padding-top: 80px;
        .yikan {
          font-size: 24px;
          text-align: center;
          padding-bottom: 40px;
          color: #333333;
          span {
            font-size: 54px;
            font-weight: 500;
            color: #ff5d5d;
          }
        }
        .progress {
          padding: 0 20px 60px;
          .jindu {
            padding-top: 20px;
            display: flex;
            justify-content: space-between;
            color: #666666;
          }
        }
      }
    }
    .item3 {
      padding-bottom: 0.4rem;
      .cell {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        span {
          font-size: 30px;
          font-weight: 500;
          color: #333333;
        }
      }
    }
    .item4 {
      h1 {
        font-size: 36px;
        font-weight: 600;
        color: #333333;
        padding-bottom: 10px;
      }
      .txt {
        ::v-deep {
          img {
            width: 100%;
            display: block;
          }
        }
      }
    }
  }
  .footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 9;
    background: #fff;
    border-radius: 16px 16px 0 0;
    margin-left: -0.2rem;
    // ::v-deep.shangpinfuwu {
    //   z-index: 2005 !important;
    // }
    // ::v-deep.van-popup--bottom.van-popup--round {
    //   border-radius: 0.16rem 0.16rem 0px 0px;
    // }
  }
  ::v-deep.van-popup--center {
    background-color: unset;
  }
  .line5 {
    margin: 0 0.5rem 0.6rem;
    .btn1,
    .btn2,.btn3 {
      border-radius: 16px;
      display: block;
      text-align: center;
      padding: 28px 0;
    }
    .btn1,.btn3 {
      background: linear-gradient(135deg, #ffa000 0%, #ff6600 100%);
      box-shadow: 0px 8px 12px 0px rgba(255, 117, 0, 0.2);
      font-size: 32px;
      color: #fff;
      margin-bottom: 30px;
     font-family: PingFangSC-Medium, PingFang SC;
    }
    .btn1{
      span{
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
      }
    }
    .btn2 {
      background: rgba(255, 136, 0, 0.1);
      font-size: 28px;
      color: #ff6600;
      font-family: PingFangSC-Medium, PingFang SC;
    }
  }
  .line6 {
    padding: 0.4rem 0.3rem;
    background: #f8f8f8;
    border-radius: 20px;
    color: #666666;
    .tit {
      text-align: center;
      margin-bottom: 0.4rem;
      .tit-span {
        img {
          width: 70px;
          vertical-align: baseline;
        }
      }
      .s1 {
        font-size: 28px;
        font-weight: 400;

        padding: 0 14px;
      }
    }
    .info {
      line-height: 0.5rem;
      color: #666;
    }
    .list {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #333333;
      .left,
      .middle,
      .right {
        padding: 0.15rem 0;
      }
      .left {
        text-align: left;
        width: 50px;
        display: flex;
        align-items: center;
        padding-right: 20px;
        img{
          border-radius: 50%;
        }
      }
      .middle {
        flex: 1;
        background: none;
      }
      .right {
        text-align: right;
      }
    }
  }
  .shangpinfuwu {
    ::v-deep.van-action-sheet__header {
      text-align: left;
      font-size: 0.36rem;
      font-weight: 600;
      color: #333333;
      padding-left: 0.4rem;
      padding-top: 0.4rem;
    }
    ::v-deep.van-card {
      background: #fff;
      padding: 0.4rem 0;
      border-top: 1px solid #eee;
    }
    ::v-deep.van-card__title {
      font-size: 0.28rem;
      font-weight: 500;
      color: #333333;
      width: 4rem;
    }
    ::v-deep.van-card__price {
      color: #dd2b1e;
    }
    ::v-deep.van-card__num {
      color: #333333;
          position: absolute;
    right: 0;
    top: 1%;
    line-height: 1;
    }
  }
  .wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  .block {
    margin: 0 0.8rem 0.6rem;
    padding: 0 0.48rem 0.42rem;
    background: rgba(255, 255, 255, 1);
    border-radius: 0.2rem;
  }
  @media (min-device-width: 320px) and(max-device-width:414px) and(-webkit-min-device-pixel-ratio:2) {
    .block {
      margin-top: 1rem;
    }
  }
}
.kanjia {
  .tit {
    padding: 0.4rem 0 0;
    font-size: 28px;
    font-weight: 500;
    color: #333333;
    text-align: center;
  }
  .info {
    color: #333333;
    text-align: center;
    padding-top: 0.6rem;
    padding-bottom: 0.4rem;
    word-break: keep-all;
    span {
      color: #ff5d5d;

      font-weight: 500;
    }
    span:first-child {
      font-size: 48px;
    }
  }
  .progress {
    ::v-deeep.van-progress {
      border-radius: 14px;
    }
    .progress_out{
    display:inline-block;
    width:100%;
    height:28px;
    background: #FFEEED;
    border-radius: 14px;
    position:relative;
    top:0;
    left:0;
    overflow: hidden;
    .progress_in{
        display:inline-block;
        height:28px;
        background: linear-gradient(135deg, #FFA000 0%, #FF6600 100%);
        border-radius: 14px;
        background-position:center right;
        position:absolute;
        top:0;
        left:0;
    }
}
    .jindu {
      padding-top: 20px;
      display: flex;
      justify-content: space-between;
      color: #666666;
    }
  }
  .btn {
    padding: 60px 0 30px;
    a {
      background: linear-gradient(135deg, #ffa000 0%, #ff6600 100%);
      box-shadow: 0px 8px 12px 0px rgba(255, 117, 0, 0.2);
      font-size: 32px;
      color: #fff;
      border-radius: 16px;
      padding: 28px 0;
    }
  }
  .topImg {
    // margin-top: -1.2rem;
    width: 120px;
    height: 120px;
    box-shadow: 0px 4px 12px 0px rgba(91, 91, 91, 0.1);
    border: 3px solid #ffffff;
    margin: auto;
    border-radius: 50%;
  }
  .topImg2 {
    text-align: center;
  }
  .friends {
    padding-top: 0.4rem;
    text-align: center;
    .tou {
      line-height: 1;
      padding-bottom: 20px;
      img {
        width: 50px;
        height: 50px;
        margin-left: -10px;
        border-radius: 50%;
      }
      &:first-child {
        margin-left: 0;
      }
    }
    .name {
      font-size: 28px;
      font-weight: 500;
      color: #333333;
    }
  }
}
.isFollow{
  h2{
    color: #FF8800;
    font-size: 0.5rem;
  }
  span{
      color: #00B095;
      font-size: 0.28rem;
    }
    .code{
      width: 3.78rem;
      padding: 0.4rem 0;
    }
}

}
#saveImg {
  position: fixed;
  top: 0;
  width: 100%;
  // height: 100vh;
  z-index: -2;
  overflow: hidden;
  background:  #DE1B2B;
.saveBg{
  width:100%;
height: 100%;
// background: #DE1B2B url("../img/saveImg.png") no-repeat center 0;
// background-size: 100% 100%;
}
.info {
  // width: 6.3rem;
  // height:8.34rem;
  width: 80%;
    height: 50%;
    position: absolute;
    top: 52%;
    left: 50%;
    transform: translate(-50%,-50%);
    text-align: center;
    .code {
      margin: 10% 0;
      img{
        width: 40%;
      }
      p {
        padding-top: 0.2rem;
        font-size: 36px;
        font-weight: 500;
        color: #333333;
      }
    }
  }
}
.kanjiaxiadan{
    padding: 0.6rem !important;
    width: fit-content !important;
    img{
      width: 1rem !important;
      height: 1rem !important;
    }
    ::v-deep.van-toast__text{
      font-size: 0.3rem;
      margin-top:0.4rem;
    }
}
.font{
          font-family: HelveticaNeue-Medium, HelveticaNeue;
        }
img {
  width: 100%;
  vertical-align: bottom;
}
.flex {
  display: flex;
  align-items: center;
  justify-content: center;
}
.mainbg1 {
  background: linear-gradient(135deg, #ffa000 0%, #ff6600 100%);
}
.mainbg2 {
  background: linear-gradient(135deg, #dddddd 0%, #aaaaaa 100%);
}
.color1 {
  color: #ff5d5d;
}
.color2 {
  color: #999999;
}
.fontSize20 {
  font-size: 20px;
}
.fontSize22 {
  font-size: 22px;
}
.fontSize30 {
  font-size: 30px;
}
.fontSize44 {
  font-size: 44px;
}
</style>
